import { render, staticRenderFns } from "./SurveyForm.vue?vue&type=template&id=568b6976&scoped=true&"
import script from "./SurveyForm.vue?vue&type=script&lang=js&"
export * from "./SurveyForm.vue?vue&type=script&lang=js&"
import style0 from "./SurveyForm.vue?vue&type=style&index=0&id=568b6976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b6976",
  null
  
)

export default component.exports